

const SplittingModal = ({SplitData}) => {
 
   
    // const Splits = JSON.parse(localStorage.getItem("Splits"));
 
  

  return (
    <>
      <div
        className="modal fade"
        id="SplittingConfirmationModal"
        tabIndex={-1}
        aria-labelledby="delete"
        
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="title-model ">Split Data</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  {/* Splits */}
                 {SplitData?.map((item,index)=>{
                    return (
                        // <p>{item}</p>
                        <div dangerouslySetInnerHTML={
                        {  __html: item}
                      } className="p-1 border-bottom"/>
                    )
                 })}
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </>
  );
};

export default SplittingModal;
